import { useYandexMetrikaSource } from '@booking/utils/useMetrics'

/** Запоминает параметры склейки сессий до первой навигации: страницы могут убрать query раньше, чем загрузится компания */
export default defineNuxtPlugin(() => {
  useYandexMetrikaSource()
})
